import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";

import moment from "moment";
import AppRating from "../../components/Common/AppRating";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomDateRangePicker from "../../components/Form/CustomDateRangePicker";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import { exportProductSalesReport, getProductSalesReport, resetReportAttachmentState } from "../../store/actions";
import "./report.css";

const SalesByProduct = ({ categoryList, manufacturerList, productSalesListing, productSalesDocument, userPermission }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [platformFilter, setPlatformFilter] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [manufacturerFilter, setManufacturerFilter] = useState("");
    const [sort_by, setSortBy] = useState('asc');
    const [dateModalOpen, setDateModalOpen] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState([null, null]);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [sort, setSorted] = useState("id")
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const [content, setContent] = useState({
        open: false,
        title: "",
        msg: "",
        buttonTitle: "",
        action: "",
        id: "",
    })

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const platformList = [
        { value: "all", label: "All platforms" },
        { value: "aspeed", label: "Aventrix" },
        { value: "ariba", label: "Ariba" },
    ]

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-reporting") && setExportable(true);
            userPermission?.includes("view-reporting") && setViewable(true);
            !userPermission?.includes("view-reporting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, length, sort, sort_by, platformFilter, categoryFilter, manufacturerFilter, startDate, endDate]);

    useEffect(() => {
        if (productSalesDocument?.code === 'success' && productSalesDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(productSalesDocument.excel_base64, 'sales_by_product_listing');
            dispatch(resetReportAttachmentState());
        }
        setLoading(false);
    }, [productSalesDocument])

    const initData = () => {
        dispatch(getProductSalesReport({
            sort: sort || '',
            sort_by: sort_by || '',
            platform: platformFilter === 'all' ? '' : platformFilter,
            category: categoryFilter === 'all' ? '' : categoryFilter,
            manufacturer: manufacturerFilter === 'all' ? '' : manufacturerFilter,
            from_date: startDate || '',
            to_date: endDate || '',
            page: page,
            length: length,
        }))
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleSetDateRange = (e) => {
        setPage("1");
        if (e) {
            setDateRange(e);
            setStartDate(moment(e[0]).format('YYYY-MM-DD'));
            setEndDate(moment(e[1]).format('YYYY-MM-DD'));
        } else {
            setDateRange(null);
            setStartDate(null);
            setEndDate(null);
        }
    }

    const handleExport = () => {
        setLoading(true);
        let filter = {
            sort: sort || '',
            sort_order: sort_by || '',
            created_date_from: startDate || '',
            created_date_to: endDate || '',
            sales_platform: platformFilter || '',
            category_id: categoryFilter || '',
            manufacturer_id: manufacturerFilter || '',
        }

        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all' || filter[key] === "0") {
                delete filter[key];
            }
        });

        dispatch(exportProductSalesReport(filter))
    }

    const resetFilter = () => {
        setPage("1");
        setDateRange([]);
        setStartDate(null);
        setEndDate(null);
        setPlatformFilter('');
        setCategoryFilter('');
        setManufacturerFilter('');
    }

    const header = [
        {
            Header: "Product",
            columnID: "product_name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div style={{ paddingRight: "5px" }}>{cellProps?.product_name || '-'}</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "SKU",
            columnID: "sku",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.sku || '-'}</div>
                    </React.Fragment>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Category",
            columnID: "category",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.category_names || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Total units sold",
            columnID: "unit_sold",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.total_unit_sold || '0.00'}</div>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sales(S$)",
            columnID: "total_sales",
            accessor: (cellProps) => {
                return (
                    <div>{cellProps?.total_sales || '0.00'}</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Average rating",
            columnID: "rating",
            accessor: (cellProps) => {
                return (
                    <AppRating rating={cellProps?.average_rating || 0} />
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Stock availability",
            columnID: "status",
            accessor: (cellProps) => {
                return (
                    <div style={{ color: cellProps?.status !== 'In stock' ? '#44d62c' : '#34C759' }}>
                        {cellProps?.status}
                    </div>
                )
            },
            disableFilters: true,
            filterable: false,
        }
    ]

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3.5} md={4.5} xs={12}>
                        <CustomDateRangePicker
                            open={() => setDateModalOpen(true)}
                            close={() => setDateModalOpen(false)}
                            isOpen={dateModalOpen}
                            startDate={(startDate && moment(startDate).format('DD MMM YYYY')) || 'dd/mm/yyyy'}
                            endDate={(endDate && moment(endDate).format("DD MMM YYYY")) || 'dd/mm/yyyy'}
                            handleSetDateRange={handleSetDateRange}
                            value={dateRange}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3.5} xs={12}>
                        <CustomSelect2
                            values={platformFilter || "all"}
                            onChange={(e) => { setPage("1"); setPlatformFilter(e) }}
                            data={platformList}
                            placeholder={"All Platform"}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3.5} xs={12}>
                        <CustomSelect2
                            values={categoryFilter || "all"}
                            onChange={(e) => { setPage("1"); setCategoryFilter(e) }}
                            data={categoryList || []}
                            placeholder={"All Categories"}
                        />
                    </Grid>
                    <Grid item lg={2.5} md={3.5} xs={12}>
                        <CustomSelect2
                            values={manufacturerFilter || "all"}
                            onChange={(e) => { setPage("1"); setManufacturerFilter(e) }}
                            data={manufacturerList || []}
                            placeholder={"All Manufacturer"}
                        />
                    </Grid>
                    <Grid item lg={1} md={2} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content textColor" style={{ minHeight: 850 }}>
                <LoadingDialog open={loading || !productSalesListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <DeleteModal setContent={setContent} content={content} />
                    <div className="header mb-2">Sales by Product</div>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={productSalesListing?.data || []}
                        getLengthPage={getLengthPage}
                        pageSize={length}
                        totalPage={productSalesListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort_by}
                        setSorted={setSortBy}
                        sort_by={sort}
                        setSortBy={setSorted}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={productSalesListing?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ General, Report, Login }) {
    let manufacturerList = [{ name: 'All Manufacturers', id: 'all' }, ...General.manufacturers];
    let categoryList = [{ name: 'All Categories', id: 'all' }, ...General.categories];
    return {
        categoryList: categoryList,
        manufacturerList: manufacturerList,
        productSalesListing: Report.productSalesListing.data,
        productSalesDocument: Report.productSalesDocument,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(SalesByProduct);
